export const HEADER_1 = 'h1';
export const HEADER_2 = 'h2';
export const HEADER_3 = 'h3';
export const PARAGRAPH = 'p';
export const LIST = 'ul';
export const ORDERED_LIST = 'ol';
export const SINGLE_LINE_COMPONENTS = [HEADER_1, HEADER_2, HEADER_3, PARAGRAPH];
export const LISTS = [LIST, ORDERED_LIST];
